<template>
  <v-card outlined class="px-6 elevation-0">
    <v-card-title class="px-0">
      Tài liệu
    </v-card-title>
    <v-card-text>
      <div class="pb-6 d-flex justify-space-between align-center" v-if="role.type !== 'inspector'">
        <v-spacer></v-spacer>
        <v-btn color="primary" class="elevation-0" @click="upload" :disabled="!typeId">
          <span>Upload tệp</span>
          <input ref="uploader" type="file" class="d-none" accept=".pdf, .xlsx, .doc, .docx" @change="onFileChanged" />
        </v-btn>
      </div>
      <div class="d-flex align-center justify-space-between px-6 py-4" v-if="selecteds && selecteds.length">
        <div class="d-flex flex-column">
          <span>
            {{ 'Đã chọn ' + selecteds.length + ' file' }}
          </span>
        </div>

        <v-btn small color="primary" @click="removeFiles">Xóa file</v-btn>
      </div>
      <ManagerDocumentDataTable :selected.sync="selecteds" v-if="typeId" :hasData="true" ref="table" />

      <ManagerDocumentDataTable :selected.sync="selecteds" v-else :hasData="false" ref="table" />
    </v-card-text>
  </v-card>
</template>

<script>
import ManagerDocumentDataTable from '@/modules/managerDocument/ManagerDocumentDataTable.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ManagerDocumentDataTable
  },
  data() {
    return {
      isSelecting: false,
      typeId: '',
      documentType: {},
      selecteds: []
    }
  },
  props: {
    documentTypeId: {
      type: String
    }
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role', 'user'])
  },
  watch: {
    documentTypeId: {
      immediate: true,
      handler(newVal) {
        this.typeId = newVal
        if (newVal) {
          this.fetchDocumentType(newVal).then(type => {
            this.documentType = type
            this.search()
          })
        } else {
          this.documentType = {}
          this.selecteds = []
        }
      }
    }
  },
  methods: {
    ...mapActions('Documents', ['createDocument', 'removeDocument', 'removeDocuments', 'fetchDocumentType']),
    ...mapActions('upload', ['uploadFile']),

    upload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      const file = e.target.files[0]

      let createdDocument = {}
      try {
        // create document
        const data = {
          documentType: this.typeId,
          createdUser: this.user.id
        }
        createdDocument = await this.createDocument(data)
        // upload file
        let formData = new FormData()
        formData.append('files', file)
        formData.append('refId', createdDocument.id)
        formData.append('ref', 'document')
        formData.append('field', 'file')

        await this.uploadFile(formData)

        this.$alert.success('Tải file thành công')
        await this.$refs.table.refresh({ documentType: this.typeId })
      } catch (error) {
        this.$alert.error('Tải file thất bại, vui lòng thử lại. Lỗi: ' + error)
        if (createdDocument.id) await this.removeDocument(createdDocument.id)
      } finally {
        this.$loading.active = false
      }
    },
    async search() {
      if (this.typeId) {
        await this.$refs.table.refresh({ documentType: this.typeId })
      }
    },
    async removeFiles() {
      this.$dialog.confirm({
        title: 'Xóa tài liệu',
        text: `Bạn có Chắc Chắn muốn xóa ${this.selecteds && this.selecteds.length} tài liệu này không ?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.removeDocuments(this.selecteds.map(f => f.id))
            await this.search()
            this.$alert.deleteSuccess()
            this.selecteds = []
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
<style scoped></style>
